"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export const FunctionSurveyCreateSchema = z.object({
//     kind: z.literal('survey_create'),
//     survey: z.string(),
//     data: z.union([z.string(), z.record(z.string(), z.unknown())]).transform((item) => {
//         if (typeof item === 'string') {
//             return JSON.parse(item);
//         }
//         return item;
//     }),
// });
// export const FunctionJokeCreateSchema = z.object({
//     kind: z.literal('joke_create'),
// });
// export const AnyFunctionSchema = z.discriminatedUnion('kind', [
//     FunctionSurveyCreateSchema,
//     FunctionJokeCreateSchema,
// ]);
//# sourceMappingURL=functionCallSchema.js.map